import { http } from '../utils/http/index'

export class computerPepairApi {
  // 预约提交
  async reservation(params: any) {
    return http.post('/user/repair/reservation', params)
  }

  // 预约记录
  async myReservationList(params: any) {
    return http.get('/user/repair/myReservationList', params)
  }
  // 预约取消
  async reservationCancel(params: any) {
    return http.put('/user/repair/reservationCancel', params)
  }
}
